export default "__VITE_PUBLIC_ASSET__bb0ab765__"